import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux-stores/store";
import { setEnableNotificationsPopupVisibility } from "../../redux-stores/slices/layoutSlice";
import { App } from "@capacitor/app";
import { registerPushDevice } from "../../lib/registerPushNotifications";
import { getNotificationPermissionStatus } from "../../lib/pushNotifications";
import { AndroidSettings, IOSSettings, NativeSettings } from "capacitor-native-settings";
import { useScrollLock } from "../../hooks/useScrollLock";

const EnableNotificationsPopup: React.FC = () => {
    const { enable_notifications_popup_visibility: show } = useSelector(
        (state: RootState) => state.layout
    );

    const { lockScroll, unlockScroll } = useScrollLock();

    const dispatch: AppDispatch = useDispatch();


    useEffect(() => {
        if (show) lockScroll()

        return () => {
            unlockScroll()
        }
    }, [show])

    const onClose = () => {
        dispatch(setEnableNotificationsPopupVisibility(false));
    };

    const onEnable = async () => {
        try {
            await registerPushDevice();

            const perm = await getNotificationPermissionStatus();

            dispatch(setEnableNotificationsPopupVisibility(false));

            if (perm !== "granted") {
                await NativeSettings.open({
                    optionAndroid: AndroidSettings.ApplicationDetails,
                    optionIOS: IOSSettings.App,
                });
            }
        } catch (err) {
            console.error("Failed to enable notifications", err);
        }
    };

    if (!show) return null;

    return (
        <>
            {/* Backdrop */}
            <div className="modal-backdrop fade show"></div>

            {/* Modal */}
            <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
                aria-modal="true"
            >
                <div className="modal-dialog modal-dialog-centered justify-content-center">
                    <div className="modal-content border-0 rounded-4 shadow" style={{ width: '90%' }}>
                        <div className="modal-body text-center p-4">
                            {/* Icon */}
                            <div className="mb-3">
                                <div
                                    className="mx-auto d-flex align-items-center justify-content-center rounded-circle"
                                    style={{
                                        width: 72,
                                        height: 72,
                                        background: "#EAF3FF",
                                        fontSize: 32,
                                    }}
                                >
                                    🔔
                                </div>
                            </div>

                            <h5 className="fw-bold mb-2">Want to stay updated?</h5>

                            <p className="text-muted mb-4">
                                Enable notifications to get updates about campaigns,
                                collaborations, offers and important alerts.
                            </p>

                            {/* Enable Button */}
                            <button
                                className="new-ui-btn w-100 mb-2"
                                onClick={onEnable}
                            >
                                Yes, Enable Notifications
                            </button>

                            {/* Not Now */}
                            <button
                                className="btn btn-link text-muted text-decoration-none"
                                onClick={onClose}
                            >
                                Not now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EnableNotificationsPopup;
